import { render, staticRenderFns } from "./FieldWorkplaceWrite.vue?vue&type=template&id=000bf820&scoped=true"
import script from "./FieldWorkplaceWrite.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceWrite.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplaceWrite.vue?vue&type=style&index=0&id=000bf820&prod&scoped=true&lang=scss"
import style1 from "./FieldWorkplaceWrite.vue?vue&type=style&index=1&id=000bf820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000bf820",
  null
  
)

export default component.exports